import React, { useContext, useState } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import useApiFunction from "../../api/useApiFunction";
import valueContext from "../../customHook/useContext";

function Withdrawal() {
  let [withdrawal, setWithdrawal] = useState({});
  const { joinMemberToken } = useContext(valueContext);

  const token = joinMemberToken();

  const [data, setData] = useState("");
  const [load, setLoad] = useState(false);
  const [showOtp, setShowOtp] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { formDataFunc } = useApiFunction();
  const navigate = useNavigate();
  const Handle = e => {
    setWithdrawal({ ...withdrawal, [e.target.name]: e.target.value });
  };
  async function getWithdrawal() {
    const res = await formDataFunc(
      "member/get-withdrawal-report",
      JSON.stringify({}),
      "POST",
      token
    );

    if (res.status) {
      setData(res.msg);
    } else if (
      res.error &&
      (res.error === "ERROR_TOKEN_INVALID0" ||
        res.error === "ERROR_TOKEN_INVALID1" ||
        res.error === "user not registered" ||
        res.error === "ERROR_TOKEN_INVALID2" ||
        res.error === "ERROR_TOKEN_INVALID3" ||
        res.error === "unauthorized" ||
        res.error === "Your session has expierd Please login again 1" ||
        res.error === "Your session has expierd Please login again 2")
    ) {
      navigate("/login");
    } else if (res.error) {
      toast.warning(res.error, { autoClose: 2000 });
    } else {
      toast.warning(res.msg, {
        autoClose: 2000
      });
    }
  }

  async function submitWithdrawal() {
    setIsLoading(true);
    if (!withdrawal.amount || !withdrawal.otp) {
      toast.warning("Please fill all the details", {
        autoClose: 2000
      });
    } else {
      let body = JSON.stringify({
        amount: withdrawal.amount,
        otp: withdrawal.otp
      });
      const res = await formDataFunc(`member/withdrawal`, body, "POST", token);
      if (res.status) {
        toast.success(res.msg, { autoClose: 2000 });
        setLoad(prv => !prv);
        setWithdrawal({ amount: "", otp: "" });
        setShowOtp(false);
      } else if (
        res.error &&
        (res.error === "ERROR_TOKEN_INVALID0" ||
          res.error === "ERROR_TOKEN_INVALID1" ||
          res.error === "user not registered" ||
          res.error === "ERROR_TOKEN_INVALID2" ||
          res.error === "ERROR_TOKEN_INVALID3" ||
          res.error === "unauthorized" ||
          res.error === "Your session has expierd Please login again 1" ||
          res.error === "Your session has expierd Please login again 2")
      ) {
        window.localStorage.removeItem("_A");
        window.localStorage.removeItem("_B");
        window.localStorage.removeItem("_C");
        navigate("/login");
      } else if (res.error) {
        toast.warning(res.error, { autoClose: 2000 });
      } else if (res.msg === "Your OTP is expired") {
        setShowOtp(false)
      } else {
        toast.warning(res.msg, { autoClose: 2000 });
      }
    }
    setIsLoading(false);
  }

  async function sendOtp() {
    setIsLoading(true);
    let body = JSON.stringify({});
    const res = await formDataFunc(
      `member/send_withdrawal_otp`,
      body,
      "POST",
      token
    );
    if (res.status) {
      toast.success(res.msg, { autoClose: 2000 });
      setLoad(prv => !prv);
      // setWithdrawal({ amount: "", address: "" });
      setShowOtp(true);
    } else if (
      res.error &&
      (res.error === "ERROR_TOKEN_INVALID0" ||
        res.error === "ERROR_TOKEN_INVALID1" ||
        res.error === "user not registered" ||
        res.error === "ERROR_TOKEN_INVALID2" ||
        res.error === "ERROR_TOKEN_INVALID3" ||
        res.error === "unauthorized" ||
        res.error === "Your session has expierd Please login again 1" ||
        res.error === "Your session has expierd Please login again 2")
    ) {
      window.localStorage.removeItem("_A");
      window.localStorage.removeItem("_B");
      window.localStorage.removeItem("_C");
      navigate("/login");
    } else if (res.error) {
      toast.warning(res.error, { autoClose: 2000 });
    } else {
      toast.warning(res.msg, { autoClose: 2000 });
    }

    setIsLoading(false);
  }
  useEffect(() => {
    getWithdrawal();
  }, [load]);

  return (
    <>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0 font-size-18">Member Withdrawal</h4>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-8">
                <div className="card profile-section">
                  <div className="card-body">
                    <div className="col-lg-12 col-md-12 col-sm-6">
                      <form>
                        <div className="form-group mb-3">
                          <label for="" className="sub-heading col-form-label">
                            Amount
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            placeholder="Enter Amount"
                            value={withdrawal.amount}
                            name="amount"
                            onChange={e => {
                              Handle(e);
                            }}
                          />
                        </div>

                        {showOtp ? (
                          <>
                            <div className="form-group mb-3">
                              <label
                                for=""
                                className="sub-heading col-form-label"
                              >
                                Otp
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter OTP"
                                name="otp"
                                value={withdrawal.otp}
                                onChange={e => {
                                  Handle(e);
                                }}
                              />
                            </div>
                            <div className="mt-3">
                              <button
                                className="block-menu"
                                type="button"
                                disabled={isLoading}
                                onClick={() => submitWithdrawal()}
                              >
                                {isLoading && (
                                  <i
                                    className="bx bx-loader-circle rotating"
                                    style={{ marginRight: "5px" }}
                                  />
                                )}
                                Submit Request
                              </button>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="mt-3">
                              <button
                                className="block-menu"
                                type="button"
                                disabled={isLoading}
                                onClick={() => sendOtp()}
                              >
                                {isLoading && (
                                  <i
                                    className="bx bx-loader-circle rotating"
                                    style={{ marginRight: "5px" }}
                                  />
                                )}
                                Send Otp
                              </button>
                            </div>
                          </>
                        )}
                      </form>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-12">
                <div className="card">
                  <div className="card-body">
                    <div className="table-responsive">
                      <h4 className="card-title table-head">
                        Withdrawal Request List
                      </h4>

                      <div className="table-responsive table-line">
                        <table
                          className="table align-middle mb-0"
                          id="order-listing"
                        >
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Address</th>
                              <th>Amount</th>
                              <th>Deduction</th>
                              <th>Transfer withdrawal</th>
                              <th>Date</th>
                              <th>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {data && data?.length > 0 ? (
                              data.map((data, i) => {
                                return (
                                  <tr>
                                    <th scope="row">{i + 1}</th>
                                    <td>{data?.address}</td>
                                    <td>{data?.amount} TLIFE</td>
                                    <td>
                                      {" "}
                                      {Math.floor(data?.deduction * 10000) /
                                        10000}{" "}
                                      TLIFE
                                    </td>
                                    <td>
                                      {Math.floor(data?.trans_amount * 10000) /
                                        10000}{" "}
                                      TLIFE
                                    </td>
                                    <td>{data?.date}</td>
                                    <td>
                                      {data?.status == "0"
                                        ? "Pending"
                                        : data?.status == "1"
                                        ? "Success"
                                        : "Refunded"}
                                    </td>
                                  </tr>
                                );
                              })
                            ) : (
                              <p>NO DATA</p>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
}

export default Withdrawal;
